import { StickyShareButtons } from 'sharethis-reactjs';
import { useEffect, useRef } from 'react';
import { useAppSelector } from 'hooks';
import chainLinkIcon from '../../assets/icons/chain-link.svg';

const CustomShareButtons: React.FC = () => {
  const editorData = useAppSelector((state) => state.quilt.editableQuilt);
  const stickyShareButtonsContainerRef = useRef<HTMLDivElement | null>(null);
  const currentPageUrl = window.location.href;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(currentPageUrl);
  };

  const sendMail = () => {
    const emailSubject = 'Someone has shared a memorial quilt square with you';
    const emailBody = `A virtual quilt square has been made in memory of ${editorData.firstName} ${editorData.lastName} on the Canadian Healing Quilt. You are invited to view this memorial at: ${window.location.href}`;
    window.location.href = `mailto:?subject=${emailSubject}&body=${emailBody}`;
  };

  // logic for adding custom instagram and copy link (change mailru and vk)
  useEffect(() => {
    if (!stickyShareButtonsContainerRef.current) return;

    const stickyShareButtonRef = stickyShareButtonsContainerRef.current?.firstElementChild || null;

    setTimeout(() => {
      const vkShareButton = stickyShareButtonRef?.childNodes.item(0) as HTMLImageElement;
      const copyPageUrlButton = vkShareButton?.cloneNode(true) as HTMLImageElement;
      const copyPageUrlButtonImg = copyPageUrlButton?.firstElementChild as HTMLImageElement;
      const copyPageUrlButtonText = copyPageUrlButton?.lastElementChild as HTMLImageElement;

      const emailButtonOrig = stickyShareButtonRef?.childNodes.item(4) as HTMLImageElement;
      const newEmailButton = emailButtonOrig?.cloneNode(true) as HTMLImageElement;

      if (!vkShareButton || !copyPageUrlButton || !newEmailButton) return;

      copyPageUrlButton.style.backgroundColor = '#007bff';
      copyPageUrlButtonImg.src = chainLinkIcon;
      copyPageUrlButtonText.textContent = 'Copy';

      copyPageUrlButton.addEventListener('click', () => {
        copyToClipboard();
        copyPageUrlButtonText.textContent = 'Copied!';
      });
      newEmailButton.addEventListener('click', sendMail);

      // replace old to new icon
      stickyShareButtonRef?.replaceChild(copyPageUrlButton, vkShareButton);
      stickyShareButtonRef?.replaceChild(newEmailButton, emailButtonOrig);
    }, 300);
  }, [stickyShareButtonsContainerRef.current, sendMail]);

  return (
    <div ref={stickyShareButtonsContainerRef} className="hiddenInPrint">
      <StickyShareButtons
        config={{
          alignment: 'right',
          color: 'social',
          enabled: true,
          font_size: 16,
          labels: 'cta',
          language: 'en',
          min_count: 0,
          networks: ['vk', 'facebook', 'linkedin', 'twitter', 'email'],
          padding: 12,
          radius: 4,
          show_total: false,
          show_mobile: true,
          show_toggle: true,
          size: 48,
          top: 320,
        }}
      />
    </div>
  );
};

export { CustomShareButtons };
